import { atom } from 'recoil';
import { TRAFFIC_TYPE } from 'pages/provisioning/aws/external-url-onboarding/constant';

export const toggleSspModels = atom({
    key: 'url-onboard-toggleSspModels',
    default: {
        isCost: { costType: '', isCostOpen: false },
        isTagOpen: false,
        isApplicationOpen: false,
        isSubmitOrderSuccess: false,
        isUpdatedToCart: false,
        isCostSplitOpen: false,
        isTargetInstanceOpen: false,
        isHealthCheckOpen: false,
    },
});

export const isValidISANumber = atom({
    key: 'awsexternal-url-isValidISANumber',
    default: false,
});

export const isValidScanNumber = atom({
    key: 'awsexternal-url-isValidScanNumber',
    default: false,
});

export const isEnvDetailsLoading = atom({
    key: 'url-onboard-isEnvDetailsLoading',
    default: false,
});

export const orderId = atom({
    key: 'url-onboard-orderId',
    default: '',
});

export const isValidOwners = atom({
    key: 'url-onboard-isValidOwners',
    default: {
        isvalidAppOwner: true,
    },
});

export const sspSubmitOrder = atom({
    key: 'url-onboard-sspOrder',
    default: {
        // Application Section
        securityScanCompleted: 'no',
        entityDetails: null,
        appProfile: null,
        applicationName: null,
        sector: null,
        sectorDetails: null,
        department: null,
        appRegion: null,
        environment: null,
        hCode: null,
        hCodeDetails: null,
        appUrl: null,
        appOwner: null,
        appOwnerDetails: null,
        dataClassification: null,
        adCertGroup: null,
        appSupportMailId: null,
        landingZoneDetails: null,

        // Resource Section
        availabilityZone: [],
        loadBalancerType: 'external',
        trafficType: TRAFFIC_TYPE.ALB,
        supportBackendCertificate: null,
        isAlbRequired: null,
        // Yes Scenario
        albNameInternal: null,
        albArn: null,
        instanceId: 'no',
        targets: [],
        targetsDetail: [],
        // No Scenario
        appShortName: null,
        albName: null,
        targetGrpName: null,
        targetGrpNameNlb: null,
        listenerPort: 443,
        listenerProtocol: 'HTTPS',
        targetType: 'IP',
        targetPort: '80',
        targetProtocol: 'HTTP',
        hcProtocol: null,
        hcProtocolDetail: null,
        hcPath: null,
        hcPort: null,
        isNlbRequired: null,
        // Yes Scenario
        nlbNameInternal: null,
        nlbArn: null,
        internalNlbName: null,
        eksClusterName: null,
        eksClusterNameDetails: null,
        // No Scenario
        nlbName: null,
        // appShortName: null,

        // Track which load balancer was set to "no" first for AppShortName cross-dependency
        albNoFirst: false,
        nlbNoFirst: false,

        tags: [],
        estimatedCost: {
            details: [],
            qty: null,
            totalOneTimeCost: {
                frequency: 'one time',
                estCost: null,
                currency: 'USD',
            },
            totalRecurringCost: {
                frequency: 'monthly',
                estCost: null,
                currency: 'USD',
            },
            notes: 'Total Est. Cost does not include the DR/backup services cost & any Pepsico internal chargebacks',
        },
        isaValidation: null,
        isaValidationMessage: null,
        isaValidationDetails: null,
        catalogCode: null,
        placeNewOrder: new Date(),
        validationStatus: 'clearValidation',
        isTouched: false,
    },
});

export const costEstimateState = atom({
    key: 'url-onboard-costEstimateState',
    default: null,
});
export const isLoadingCostApiState = atom({
    key: 'url-onboard-isLoadingCostApiState',
    default: {
        isLoading: false,
    },
});

export const isValidProvisioningForm = atom({
    key: 'url-onboard-isValidProvisioningForm',
    default: false,
});

export const isAppNameValid = atom({
    key: 'url-onboard-isAppNameValid',
    default: false,
});

export const isAppShortNameValid = atom({
    key: 'url-onboard-isAppShortNameValid',
    default: false,
});

export const isAppShortNameExist = atom({
    key: 'url-onboard-isAppShortNameExist',
    default: false,
});

export const isAppUrlValid = atom({
    key: 'url-onboard-isAppUrlValid',
    default: false,
});

export const isValidappSupportMailId = atom({
    key: 'url-onboard-isValidappSupportMailId',
    default: false,
});

export const isTargetInstanceFullfilled = atom({
    key: 'url-onboard-isTargetInstanceFullfilled',
    default: false,
});

export const isHealthCheckFullfilled = atom({
    key: 'url-onboard-isHealthCheckFullfilled',
    default: false,
});
